var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { camelCaseKeysDeep } from '@zapier/common-utils';
import { useEffect, useState } from 'react';
const useSupportEligibility = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [eligibility, setEligibility] = useState({
        isEmailSupportEligible: undefined,
        isPremierSupportEligible: undefined,
        isPaidEmailSupportEligible: undefined,
        isCriticalTicketEligible: undefined,
    });
    const [error, setError] = useState('');
    useEffect(() => {
        const fetchEligibilityData = () => __awaiter(void 0, void 0, void 0, function* () {
            const eligibilityUrl = `${process.env.ZAPIER_API_BASE_URL || ''}/api/v4/support-eligibility/`;
            try {
                const response = yield fetch(eligibilityUrl);
                if (response.ok) {
                    const result = yield response.json();
                    setEligibility(camelCaseKeysDeep(result));
                }
                else {
                    throw new Error(`Error: ${response.statusText}`);
                }
            }
            catch (err) {
                setError('An error occurred while fetching eligibility data.');
            }
            finally {
                setIsLoading(false);
            }
        });
        fetchEligibilityData();
    }, []); // Empty dependency array to run only once
    return {
        isLoading,
        eligibility,
        error,
    };
};
export default useSupportEligibility;
